module.exports = __webpack_public_path__ + "static/media/aside-citizen-report.d892c3a6.jpg";